import axios from 'axios';
import { API_BASE } from './config.js'
import { vue_instance } from './main.js';

var axios_client = axios.create({
    baseURL: API_BASE,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Autrollization' : localStorage.getItem('token')
    }
});

axios_client.interceptors.request.use((req) => {

    /**
    var page_loading = true;

     if(req.data && req.data.filters){
        if(!req.data.filters.page_loading)
            page_loading = false;
    }

    if(req.url.indexOf('page_loading=false') > -1)
        page_loading = false;


    vue_instance.$store.commit('setPageLoading', page_loading);**/

    req.headers['Autrollization'] = localStorage.getItem('token');

    return req;
}, (error) => {
    vue_instance.$store.commit('setPageLoading', true);
    return Promise.reject(error);
});

axios_client.interceptors.response.use((res) => {

    vue_instance.$store.commit('setPageLoading', false);

    if(res.data && res.data.mensaje){
        vue_instance.$store.commit('setNotify', {
            state: true,
            text: res.data.mensaje,
            color: 'success'
        });
    }

    return res;
}, (error) => {

    var response = error.response;

    if(response.status >= 500){
        vue_instance.$store.commit('setNotify', {
            state: true,
            text: 'There was an server error',
            color: 'error'
        });
    }else{
        if (response.data.mensaje) {
            vue_instance.$store.commit('setNotify', {
                state: true,
                text: response.data.mensaje,
                color: 'warning'
            });
        }         
    }

    vue_instance.$store.commit('setPageLoading', false);



    return Promise.reject(error.response);
});

export var api = {
    getPageLoading : function(){
        return vue_instance.page_loading;
    },
    base : function(){
        return axios_client;
    },

    get : function(url, options){

        var str_params = this.formatURLParams(options.filters);

        return this.base().get(url+str_params);
    },

    post : function(url, data){

        var str_params = this.formatURLParams(data.filters);

        return this.base().post(url+str_params, data);
    },

    patch : function(url, data){
        return this.base().patch(url, data);
    },

    delete : function(url, data){
        return this.base().delete(url, data);
    },

    formatURLParams : function(params){
        var str_params = '';
        if(params){
            str_params = '?';
            var parts = [];
            for(var i in params){
                parts.push(i + "=" + params[i]);
            }

            str_params = '?'+parts.join("&");
        }

        return str_params;
    }
}


// WEBPACK FOOTER //
// ./src/api.js